<style scoped>
.input-group .v-select{
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
}
</style>
<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'UpdateModal',
    props:[
        "id",
        "data",
        "editingTriger"
    ],
    data() {
        return {
            ilList : [],
            ilceList : [],
            bucakList : [],
            koyList : [],
            mahalleList : [],
            sokakList : [],
            binaList : [],
            daireList : [],
            kimlikOpen:true,
            iletisimOpen:true,
            editing:'',
            contact:{}
        };
    },
    watch:{ 
        editing(){
            this.$emit('editing', this.editing);
        },
        editingTriger(prop){
            this.editing=prop
        },
        data(props){
            this.contact = props
        }
    },
    methods: {
       update(name) {
            if(this.loadButton) return
            
            this.submitted = true;
            this.loadButton = true

            const data = name.split('.')

            this.$http.put(`members/update`, { key:name, value:this[data[0]][data[1]], id:this.id} )
            .then((resp) => {  
              this.loadButton = false;
              notify.success(resp.data.message) 
            })
          
          this.submitted = false;
        },
    },
};
</script>

<template>
  <div class="row">
    <div class="card px-0 py-0 my-0">
    <div class="card-header"  @click="iletisimOpen=!iletisimOpen">
        <h5 class="card-title my-0">İletişim Bilgileri <span class="float-end"><i class="fa fa-chevron-down"></i></span></h5>
    </div>
    <div class="card-body" v-if="iletisimOpen">
        <div class="row">
            <div class="col-md-4">
            <label for="phonenumber">Telefon</label>
                <div class="mb-3">
                    <span v-if="editing == 'contact.phonenumber'">
                        <div class="input-group">
                            <input
                                id="phonenumber"
                                v-model="contact.phonenumber"
                                type="text"
                                class="form-control"
                                placeholder="Telefon"
                            />
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.phonenumber'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                    </span>
                    <span v-else>
                        {{ contact.phonenumber }} 
                        <span class="float-end">
                            <a href="#" @click.prevent="editing = 'contact.phonenumber'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                    </span>
                </div>
            </div>
            <div class="col-md-4">
                <label for="phonenumber2">Telefon2</label>
                <div class="mb-3">
                    <span v-if="editing == 'contact.phonenumber2'">
                        <div class="input-group">
                            <input
                                id="phonenumber2"
                                v-model="contact.phonenumber2"
                                type="text"
                                class="form-control"
                                placeholder="Telefon2"
                            />
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.phonenumber2'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                    </span>
                    <span v-else>
                        {{ contact.phonenumber2 }} 
                        <span class="float-end">
                            <a href="#" @click.prevent="editing = 'contact.phonenumber2'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                    </span>
                </div>
            </div>
            <div class="col-md-4">
                <label for="email">E-Posta</label>
                 <div class="mb-3">
                    <span v-if="editing == 'contact.email'">
                        <div class="input-group">
                            <input
                                id="email"
                                v-model="contact.email"
                                type="text"
                                class="form-control"
                                placeholder="E-Posta"
                            />
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.email'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                    </span>
                    <span v-else>
                        {{ contact.email }} 
                        <span class="float-end">
                            <a href="#" @click.prevent="editing = 'contact.email'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <label for="province">İl</label>
                <div class="mb-3">
                    <span v-if="editing == 'contact.province'">
                        <div class="input-group">
                            <v-select
                                label="name" 
                                v-model="contact.province"
                                :options="ilList" 
                                :reduce="country => country.name"
                                @option:selecting="setSelected($event,'ilce')"><span slot="no-options">Sonuç Bulunamadı</span>
                            </v-select>
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.province'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                    </span>
                    <span v-else>
                        {{ contact.province }} 
                        <span class="float-end">
                            <a href="#" @click.prevent="editing = 'contact.province'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                    </span>
                </div>
            </div>
            <div class="col-md-4">
                <label for="district">İlçe</label>
                 <div class="mb-3">
                    <span v-if="editing == 'contact.district'">
                        <div class="input-group">
                            <v-select 
                                v-model="contact.district"
                                label="name" 
                                :options="ilceList" 
                                :reduce="country => country.name"
                                @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
                            </v-select>
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.district'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                    </span>
                    <span v-else>
                        {{ contact.district }} 
                        <span class="float-end">
                            <a href="#" @click.prevent="editing = 'contact.district'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                    </span>
                </div>
            </div>
            <div class="col-md-4">
                <label for="township">Bucak</label>
                 <div class="mb-3">
                    <span v-if="editing == 'contact.township'">
                        <div class="input-group">
                            <v-select 
                                label="name"  
                                v-model="contact.township"                     
                                :options="bucakList" 
                                :reduce="country => country.name"
                                @option:selecting="setSelected($event,'koy')"><span slot="no-options">Sonuç Bulunamadı</span>
                            </v-select>
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.township'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                    </span>
                    <span v-else>
                        {{ contact.township }} 
                        <span class="float-end">
                            <a href="#" @click.prevent="editing = 'contact.township'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                    </span>
                </div>
            </div>
        </div>
            <div class="row">
                <div class="col-md-4">
                    <label for="village">Köy</label>
                    <div class="mb-3">
                    <span v-if="editing == 'contact.village'">
                        <div class="input-group">
                            <v-select 
                                label="name" 
                                v-model="contact.village"
                                :options="koyList" 
                                :reduce="country => country.name"
                                @option:selecting="setSelected($event,'mahalle')"><span slot="no-options">Sonuç Bulunamadı</span>
                            </v-select>
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.village'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                    </span>
                    <span v-else>
                        {{ contact.village }} 
                        <span class="float-end">
                            <a href="#" @click.prevent="editing = 'contact.village'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                    </span>
                </div>
                   
                </div>
                <div class="col-md-4">
                    <label for="neighbourhood">Mahalle</label>
                    <div class="mb-3">
                        <span v-if="editing == 'contact.neighbourhood'">
                            <div class="input-group">
                                <v-select 
                                    label="name" 
                                    v-model="contact.neighbourhood"
                                    :options="mahalleList" 
                                    :reduce="country => country.name"
                                    @option:selecting="setSelected($event,'sokak')"><span slot="no-options">Sonuç Bulunamadı</span>
                                </v-select>
                                <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.neighbourhood'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                                <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                            </div>
                        </span>
                        <span v-else>
                            {{ contact.neighbourhood }} 
                            <span class="float-end">
                                <a href="#" @click.prevent="editing = 'contact.neighbourhood'">
                                    <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                                </a>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="street">Sokak</label>
                    <div class="mb-3">
                        <span v-if="editing == 'contact.street'">
                            <div class="input-group">
                                <v-select 
                                    label="name" 
                                    v-model="contact.street"
                                    :options="sokakList" 
                                    :reduce="country => country.name"
                                    @option:selecting="setSelected($event,'bina')"><span slot="no-options">Sonuç Bulunamadı</span>
                                </v-select>
                                <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.street'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                                <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                            </div>
                        </span>
                        <span v-else>
                            {{ contact.street }} 
                            <span class="float-end">
                                <a href="#" @click.prevent="editing = 'contact.street'">
                                    <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                                </a>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label for="buildnum">Dış Kapı No</label>
                      <div class="mb-3">
                        <span v-if="editing == 'contact.buildnum'">
                            <div class="input-group">
                                <v-select 
                                    taggable
                                    label="name" 
                                    v-model="contact.buildnum"
                                    :options="binaList" 
                                    :reduce="country => country.name"
                                    @option:selecting="setSelected($event,'daire','binaList')"><span slot="no-options">Sonuç Bulunamadı</span>
                                </v-select>
                                <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.buildnum'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                                <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                            </div>
                        </span>
                        <span v-else>
                            {{ contact.buildnum }} 
                            <span class="float-end">
                                <a href="#" @click.prevent="editing = 'contact.buildnum'">
                                    <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                                </a>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="floornum">İç Kapı No</label>
                    <div class="mb-3">
                        <span v-if="editing == 'contact.floornum'">
                            <div class="input-group">
                                <v-select
                                    label="name" 
                                    taggable
                                    v-model="contact.floornum"
                                    :options="daireList" 
                                    :reduce="country => country.name"
                                    @option:selecting="setSelected($event,'adresGetir','daireList')"
                                ><span slot="no-options">Sonuç Bulunamadı</span>
                                </v-select>
                                <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.floornum'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                                <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                            </div>
                        </span>
                        <span v-else>
                            {{ contact.floornum }} 
                            <span class="float-end">
                                <a href="#" @click.prevent="editing = 'contact.floornum'">
                                    <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                                </a>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="zipcode">Posta Kodu</label>
                    <div class="mb-3">
                        <span v-if="editing == 'contact.zipcode'">
                            <div class="input-group">
                                <input
                                    id="zipcode"
                                    v-model="contact.zipcode"
                                    type="text"
                                    class="form-control"
                                    placeholder="Posta Kodu"
                                />
                                <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.zipcode'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                                <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                            </div>
                        </span>
                        <span v-else>
                            {{ contact.zipcode }} 
                            <span class="float-end">
                                <a href="#" @click.prevent="editing = 'contact.zipcode'">
                                    <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                                </a>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="code">Adres Kodu</label>
                    <div class="mb-3">
                        <span v-if="editing == 'contact.code'">
                            <div class="input-group">
                                <input
                                    id="code"
                                    v-model="contact.code"
                                    type="text"
                                    class="form-control"
                                    placeholder="Adres Kodu"
                                />
                                <button class="btn btn-success btn-sm" type="button" @click.prevent="update('contact.code'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                                <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                            </div>
                        </span>
                        <span v-else>
                            {{ contact.code }} 
                            <span class="float-end">
                                <a href="#" @click.prevent="editing = 'contact.code'">
                                    <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                                </a>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>